<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Captcha Image</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createCaptcha'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(content.id)="row">
          <div v-html="row.value.substring(0,50)"></div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>by
          <label class="font-weight-bold">{{item.created_by_username}}</label>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.updated_by_username}}</label>
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            :to="{name: 'editCaptcha', params: {id: item.id}}"
            class="text-dark"
            v-b-tooltip.hover
            title="Edit"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img class="mr-2" src="@/assets/rectangle.svg" alt />
          </b-link> -->
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      vuex: [],
      key: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left w-10"
        },
        {
          key: "image_url",
          label: "Image",
          class: "text-center"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left w-10"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: '',
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("CaptchaModule/getCaptchas")
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.CaptchaModule.captcha,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("CaptchaModule/getCaptchas", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("CaptchaModule/getCaptchas")
            .then(response => {
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
            });
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          this.$store.dispatch("CaptchaModule/delCaptcha", id);
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style>
u {
  text-decoration: underline;
}
</style>
